import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Introduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="4865" id="faq-introduction" className="relative w-full overflow-hidden bg-background py-24 text-foreground">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-20 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:40px_40px] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_100%)]" />

      <div ref={ref} className={`container relative z-10 mx-auto px-4 text-center transition-all duration-800 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex justify-center mb-8">
          <Badge className="w-[60px] h-0.5 p-0 bg-primary border-none rounded-none text-transparent overflow-hidden pointer-events-none">
            SEPARATOR
          </Badge>
        </div>

        <h1 className="mb-6 font-serif text-[4rem] font-normal leading-tight tracking-[-0.02em] text-primary">
          Common Questions & Clear Answers
        </h1>

        <p className="mx-auto max-w-[700px] font-sans text-lg font-normal leading-relaxed text-muted-foreground">Find answers to the most frequent inquiries about my navigation services and family support, designed to provide clarity and peace of mind during your healthcare journey.</p>
      </div>
    </section>;
}